const TAG = '[WorkoutFeeling]';

/** Dev or `sessionStorage.setItem('vo2_debug_workout_feeling','1')` on production. */
export function isWorkoutFeelingDebugEnabled(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return sessionStorage.getItem('vo2_debug_workout_feeling') === '1';
  } catch {
    return false;
  }
}

export function logWorkoutFeeling(message: string, payload?: Record<string, unknown>): void {
  if (!isWorkoutFeelingDebugEnabled()) return;
  if (payload) {
    console.log(TAG, message, payload);
  } else {
    console.log(TAG, message);
  }
}
